import {
    Box,
    Title
} from "@mantine/core";
import classes from "./MarketingComponent.module.css";
import product from "../../../config/product.ts";

export const MarketingComponent = () => {

    return (
        <Box className={classes.heroImage}>
            <Title order={1}>{product.displayName}</Title>
        </Box>
    )

}
